import { applyMiddleware, combineReducers, createStore } from "redux";
import { createMigrate, persistReducer, persistStore } from "redux-persist";

import AsyncStorage from "@react-native-async-storage/async-storage";
import authSlice from "appRedux/reducers/authSlice";
import cartSlice from "../reducers/cartSlice";
import filterSlice from "../reducers/filterSlice";
import homeSlice from "appRedux/reducers/homeSlice";
import orderSlice from "../reducers/orderSlice";
import profileSlice from "appRedux/reducers/profileSlice";
import shoppableSlice from "appRedux/reducers/shoppableSlice";
import storedUtilsSlice from "appRedux/reducers/storedUtilsSlice";
import { thunk } from "redux-thunk";
import utilsSlice from "appRedux/reducers/utilsSlice";
import chatSlice from "appRedux/reducers/chatSlice";
import productSlice from "appRedux/reducers/productSlice";

const migrations = {
  2: (state) => {
    return {
      ...state,
      AuthReducer: {
        ...state.AuthReducer,
        webOpenCount: -1,
        newsPopUpShownCount: 0,
      },
    };
  },
};

const persistConfig = {
  key: "root",
  storage: AsyncStorage,
  whitelist: [
    "AuthReducer",
    "ProfileReducer",
    "HomeReducer",
    "CartReducer",
    "OrderReducer",
    "FilterReducer",
    "UtilsReducer",
    "StoredutilsSlice",
    "ChatReducer",
  ],
  migrate: createMigrate(migrations, { debug: false }),
};

const rootReducer = combineReducers({
  AuthReducer: authSlice,
  ProfileReducer: profileSlice,
  HomeReducer: homeSlice,
  CartReducer: cartSlice,
  OrderReducer: orderSlice,
  FilterReducer: filterSlice,
  UtilsReducer: utilsSlice,
  StoredutilsSlice: storedUtilsSlice,
  ShoppableSlice: shoppableSlice,
  ChatReducer: chatSlice,
  ProductSlice: productSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

let store = createStore(persistedReducer, applyMiddleware(thunk));

let persistor = persistStore(store);

export { store, persistor };
